module.exports = __webpack_public_path__ + "static/media/aboutus_triangle.8d9a99b9.svg";